import React from 'react'
import ThumbListing from './ThumbListing'
import { SectionTitle } from 'scripts/helpers/AppHelper'
import { actions } from 'scripts/store'

const Thumbnail = (props) => {
  const {title, linktype, slug, id} = props.links || props
  const {data, cssClass, titleArrow, section} = props
  if (!data) { return null }
  const customOnClick = (trackingTag) => {
    actions.setSection(section)
    actions.setArticleTag(trackingTag)
  }
  const titleProps = {title: title, type: linktype, slug: slug, id: id, arrow: titleArrow, customOnClick}
  return (
    <div className={`component-thumbnail ${cssClass || ''}`}>
      <SectionTitle {...titleProps} />
      <ThumbListing {...props} customOnClick={customOnClick} />
    </div>
  )
}

export default Thumbnail



// WEBPACK FOOTER //
// ./assets/js/components/thumbnail/Thumbnail.jsx